import { Accordion, AccordionSummary, Box } from '@mui/material';
import { Form, Formik } from 'formik';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { useState } from 'react';
import DatePickerWrapper from '../../../shared/formUtilities/useDatePicker';
import ButtonWrapper from '../../../shared/formUtilities/useButton';
import { DateHelper } from '../../../helpers/dateHelper';
import FilterHelper from '../../../helpers/filterHelper';

export const DFSAOpportunitiesFilter = ({
	loading = false,
	filter,
	onHandleFilter = (e) => { },
	onClearFilter = (e) => { },
}) => {
	const [expand, setExpand] = useState(false);
	const initialValues = {
		fromDate: FilterHelper.mapFilterStringToForm(filter, 'fromDate'),
		toDate: FilterHelper.mapFilterStringToForm(filter, 'toDate'),
	};

	function onFilter(values) {
		let formattedValues = {
			fromDate: formatDateForFilter(values?.fromDate),
			toDate: formatDateForFilter(values?.toDate),
		};
		onHandleFilter &&
			onHandleFilter(FilterHelper.checkMuliSelectValues(formattedValues));
	}

	function formatDateForFilter(date) {
		return DateHelper.formatDate(date, 'MM/dd/yyyy');
	}

	function onClear(formik) {
		formik.resetForm();
		onClearFilter && onClearFilter('');
	}

	return (
		<Box className="bg-white">
			<Formik
				initialValues={initialValues}
				enableReinitialize={true}
				onSubmit={onFilter}>
				{(formik) => {
					return (
						<Form>
							<Box className="bg-white">
								<Accordion
									sx={{ boxShadow: 'none' }}
									expanded={expand}>
									<AccordionSummary
										sx={{ margin: '0px' }}
										onClick={(e) => {
											setExpand(false);
										}}>
										<Box className="flex flex-col flex-1">
											<Box className="grid grid-cols-2 gap-4">
												<DatePickerWrapper
													key={'fromDate'}
													name={'fromDate'}
													label={'Start Date'}
												/>
												<DatePickerWrapper
													key={'toDate'}
													name={'toDate'}
													label={'End Date'}
												/>
											</Box>
										</Box>
									</AccordionSummary>
								</Accordion>
								<Box className="flex justify-end items-center px-4 py-4 pt-0">
									<Box className="flex">
										<Box>
											<ButtonWrapper
												loading={loading}
												classList="w-[140px] !mx-2"
												label="Search"
												type="submit"
												icon={<ManageSearchIcon />}></ButtonWrapper>
											<ButtonWrapper
												loading={loading}
												variant="outlined"
												onClick={(e) => onClear(formik)}
												classList="w-[140px] !text-primary"
												label="Reset"
												loaderSpinnerClass={'!text-primary'}
												icon={<ClearAllIcon />}></ButtonWrapper>
										</Box>
									</Box>
								</Box>
							</Box>
						</Form>
					);
				}}
			</Formik>
		</Box>
	);
};
